import { Button } from "components/ui/controls/Button";
import styled, { useTheme } from "styled-components";
import { DragDropProvider } from "@dnd-kit/react";
import { useContext, useState } from "react";
import { ArchiveDropZone } from "../../ui/controls/ArchiveDropZone";
import { tasksDragHandler } from "utilities/dragAndDropHandlers";
import { TasksContext } from "providers/TasksProvider";
import { TaskSettings } from "views/modules/TaskSettings";
import { useNavigate } from "react-router-dom";
import { TasksKanbanColumn } from "../tasks/TasksKanbanColumn";
import { TasksKanbanCard } from "../tasks/TasksKanbanCard";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const ProjectTasks = ({projectUuid}) => {

    const GlobalTheme = useTheme();
    const navigate = useNavigate();

    const [isDraggingActive, setIsDraggingActive] = useState(false);

    const { tasks, handleTasksEdit } = useContext(TasksContext)

    const filteredTasks = tasks.map(tsk => tsk.taskProjectUuid === projectUuid ? tsk : null);
    
    return (
        <StyledProjectTasks>
            <div className="tasksHeader">
                <div className="headerContainer">
                    <span>
                        Oppgaver
                    </span>

                    Opprett og administrer oppgaver tilknyttet til prosjektet.
                </div>
                <Button
                    prefix={<MaterialIcon name='add' weight={300}/>}
                    text='Ny oppgave'
                    onClick={() => navigate('/projects/' + projectUuid + '/task/new')}
                />
            </div>
            <div className="tasksContent">
                <DragDropProvider
                    onDragStart={() => setIsDraggingActive(true)}
                    onDragEnd={(e) => {tasksDragHandler(e, handleTasksEdit); setIsDraggingActive(false)}}
                >
                    <TasksKanbanColumn
                        id='tasks-kanban-not-started'
                        title='Planlagt'
                        counter={filteredTasks.filter(tsk => tsk && tsk.taskStatus === "NotStarted").length}
                        color={GlobalTheme.colors.neutralSecondaryForeground}
                    >
                        {
                            filteredTasks.map(tsk => tsk && tsk.taskStatus === 'NotStarted' ?<TasksKanbanCard key={tsk.taskUuid} task={tsk} src='projectSettings'/> : null)
                        }
                    </TasksKanbanColumn>

                    <TasksKanbanColumn
                        id='tasks-kanban-started'
                        title='Igangsatt'
                        counter={filteredTasks.filter(tsk => tsk && tsk.taskStatus === "Started").length}
                        color={GlobalTheme.colors.accentForeground}
                    >
                        {
                            filteredTasks.map(tsk => tsk && tsk.taskStatus === 'Started' ? <TasksKanbanCard key={tsk.taskUuid} task={tsk} src='projectSettings'/> : null)
                        }
                    </TasksKanbanColumn>

                    <TasksKanbanColumn
                        id='tasks-kanban-stopped'
                        title='Stanset'
                        counter={filteredTasks.filter(tsk => tsk && tsk.taskStatus === "Stopped").length}
                        color={GlobalTheme.colors.warningForeground}
                    >
                        {
                        filteredTasks.map(tsk => tsk && tsk.taskStatus === 'Stopped' ? <TasksKanbanCard key={tsk.taskUuid} task={tsk} src='projectSettings'/> : null)
                        }
                    </TasksKanbanColumn>

                    <TasksKanbanColumn
                        id='tasks-kanban-finished'
                        title='Fullført'
                        counter={filteredTasks.filter(tsk => tsk && tsk.taskStatus === "Finished").length}
                        color={GlobalTheme.colors.successForeground}
                    >
                        {
                            filteredTasks.map(tsk => tsk && tsk.taskStatus === 'Finished' ? <TasksKanbanCard key={tsk.taskUuid} task={tsk} src='projectSettings'/> : null)
                        }
                    </TasksKanbanColumn>
                    <ArchiveDropZone
                        isActive={isDraggingActive}
                    />
                </DragDropProvider>
            </div>
            <TaskSettings/>
        </StyledProjectTasks>
    )
}

const StyledProjectTasks = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.lg};

    div.tasksHeader
    {
        display: flex;
        align-items: center;
        justify-content: space-between;

        div.headerContainer
        {
            span
            {
                display: block;
                font-weight: 600;
                font-size: ${({theme}) => theme.fontSize.lg};
                margin-bottom: ${({theme}) => theme.spacing.sm};
                color: ${({theme}) => theme.colors.neutralSecondaryForeground};
            }

            color: ${({theme}) => theme.colors.mutedForeground};
        }
    }

    div.tasksContent
    {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        gap: ${({theme}) => theme.spacing.md};
    }
`